import lego from 'common/building-blocks/assets/lottie/lego.json';
import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

const source = lego as unknown as string;

export const lottie = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.LOTTIE> =>
	createModel({
		type: COMPONENT_TYPE.LOTTIE,
		componentProps: {
			styles: {},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.lottie.ltSrc]: source,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.LOTTIE>;
